// extracted by mini-css-extract-plugin
module.exports = {"activityTab":"activityTab__YB7n7"};